import styled from 'styled-components';

export const TnCWrapper = styled.div(
    props => `
        width:100%;
        display: flex;
    `
);

export const UserActionWrapper = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        margin-top:3rem;
    `
);

export const UserImportantInfoWrap = styled.div(
    props => `
      width: 100%;
      display: flex;
      margin-top: ${props.theme.spacing.large.l20};
      flex-direction: column;
    `,
);

export const UserConsentText = styled.label(
props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    cursor: pointer;
`,
);

export const UserTermsText = styled.span(
props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.blue.base};
`
);

export const UserTermsCheck = styled.input.attrs({type: 'checkbox'})(
props =>`
    display: inline-flex;
    margin-right: 0.5rem;
    cursor: pointer;
    vertical-align: middle;
    position: relative;
    top: -1.5px;
`
);

export const PageLoaderWrap = styled.div(
    props => `
        width:100%;
        height: 50rem;
        display: flex;
    `
)